const STORAGE_KEY = 'sueLoginError';

/**
 * Bewaar een foutmelding voor weergave op /login (bijv. na Microsoft-redirect).
 * @param {string} message
 */
export function saveLoginError(message) {
  if (typeof message === 'string' && message.trim()) {
    sessionStorage.setItem(STORAGE_KEY, message.trim());
  }
}

/**
 * @returns {string|null}
 */
export function getAndClearLoginError() {
  if (typeof sessionStorage === 'undefined') return null;
  const message = sessionStorage.getItem(STORAGE_KEY);
  if (message) sessionStorage.removeItem(STORAGE_KEY);
  return message || null;
}

function isNetworkFailure(error) {
  if (!error || error.response) return false;
  const code = error.code || '';
  const message = String(error.message || '');
  return (
    code === 'ERR_NETWORK' ||
    code === 'ECONNABORTED' ||
    /network error/i.test(message) ||
    /failed to fetch/i.test(message)
  );
}

/**
 * @param {unknown} error
 * @returns {string}
 */
export function formatEntraLoginFailure(error) {
  if (!error) {
    return 'Microsoft-inloggen is mislukt. Probeer het opnieuw.';
  }

  const err = /** @type {{ errorCode?: string; errorMessage?: string; message?: string; response?: { status?: number; data?: { detail?: unknown } } }} */ (
    error
  );

  if (err.errorCode === 'user_cancelled') {
    return 'Microsoft-inloggen is geannuleerd.';
  }

  if (isNetworkFailure(err)) {
    return (
      'Kan geen verbinding maken met de SUE-server. ' +
      'Controleer of u bent verbonden met het bedrijfsnetwerk (VPN), en probeer daarna opnieuw in te loggen met Microsoft.'
    );
  }

  const status = err.response?.status;
  const detail = err.response?.data?.detail;

  if (status === 401 || status === 403) {
    if (typeof detail === 'string' && detail.trim()) return detail;
    return 'U heeft geen toegang tot deze omgeving. Neem contact op met de beheerder.';
  }

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  const msalMessage = err.errorMessage || err.message;
  if (typeof msalMessage === 'string' && msalMessage.trim()) {
    return msalMessage;
  }

  return 'Microsoft-inloggen is mislukt. Controleer uw VPN-verbinding en probeer het opnieuw.';
}
